import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux';
import teacherActions from '../../state/teacher/actions'
import cloneDeep from 'lodash.clonedeep';

export default function BadgingLocaleConfig(props) {
  const {isDisabled} = props;

  const badgingLocale = useSelector(state => state.reports.teacher.badgingLocale);

  const dispatch = useDispatch();
  const setTeacherReduxState = update => dispatch(teacherActions.setState(update));

  const {t} = useTranslation('reports_sidebar');

  const toggleBadgingLocale = (locale) => {
    const update = cloneDeep(badgingLocale);
    update[locale] = !update[locale];
    setTeacherReduxState({badgingLocale: update});
  }

  return (
    <div className="reportsSubselection">
      <div className="reportsAdditionalSelectionTitle">{t("badges_earned_in")}</div>
      <div className="reportsRadioButtonSet">
        <div className="reportsCheckbox">
          <label>
            <input
              type="checkbox"
              checked={badgingLocale?.english || false}
              onChange={() => toggleBadgingLocale('english')}
              disabled={isDisabled}
            />
            {t("english")}
          </label>
        </div>
        <div className="reportsCheckbox">
          <label>
            <input
              type="checkbox"
              checked={badgingLocale?.spanish || false}
              onChange={() => toggleBadgingLocale('spanish')}
              disabled={isDisabled}
            />
            {t("spanish")}
          </label>
        </div>
      </div>
    </div>
  )
}
